import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MaterialModule } from "../../_shared";
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-footer',
  imports: [MaterialModule,RouterModule],
  templateUrl: './footer.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './footer.scss',
})
export class Footer {

  public year:number = new Date().getFullYear();

}
